<template>
  <section class="ph-card">
    <div class="ph-header">
      <i class="fal fa-history text-blue-500"></i>
      <h2 class="text-lg leading-6 font-medium text-blue-500 mb-0">
        {{ $t('post.page.history.history') }}
      </h2>
    </div>
    <div class="ph-body">
      <ul role="list" class="ph-list">
        <template v-if="postHistories && postHistories.length > 0">
          <component
            :is="history.entity"
            :history="history"
            v-for="history in histories"
            :key="history.id"
          />
        </template>
        <template v-else>
          <li class="ph-empty">
            <i class="fal fa-inbox"></i>
            <span>Aucun historique</span>
          </li>
        </template>
      </ul>
      <div v-if="postHistories && postHistories.length > 5" class="ph-load-more">
        <button
          v-if="loadHistory"
          @click="loadMore()"
          type="button"
          class="ph-btn ph-btn-more"
        >
          <i class="fal fa-chevron-down"></i>
          {{ $t('post.page.history.more') }}
        </button>
        <button
          v-else
          @click="loadLess()"
          type="button"
          class="ph-btn ph-btn-less"
        >
          <i class="fal fa-chevron-up"></i>
          {{ $t('post.page.history.less') }}
        </button>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import PostHistory from './History/PostHistory'
import OperatorHistory from './History/OperatorHistory'
import CommentHistory from './History/CommentHistory'
import MessageHistory from './History/MessageHistory'
import PriorityHistory from './History/PriorityHistory'
import StatusHistory from './History/StatusHistory'

export default {
  name: 'PostHistories',
  data: function() {
    return {
      loading: true,
      display: 5,
      loadHistory: true
    }
  },
  components: {
    Post: PostHistory,
    Comment: CommentHistory,
    Message: MessageHistory,
    Operator: OperatorHistory,
    Priority: PriorityHistory,
    Status: StatusHistory
  },
  computed: {
    ...mapState('post', {
      postHistories: (state) => state.history,
      post: (state) => state.post
    }),
    histories() {
      if (this.display > this.postHistories.length) {
        return this.postHistories
      }
      return this.postHistories.slice(0, this.display)
    }
  },
  watch: {
    postHistories(val) {
      if (this.display > val.length) {
        this.loadHistory = false
      }
    },
    display(val) {
      if (val > this.postHistories.length) {
        this.loadHistory = false
      }
    }
  },
  methods: {
    loadMore() {
      this.display += 5
    },
    loadLess() {
      this.display = 5
      this.loadHistory = true
    }
  },
  created() {
  }
}
</script>

<style scoped>
.ph-card {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.ph-header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px 20px;
    border-bottom: 1px solid #f1f5f9;
}

.ph-header > i {
    font-size: 1rem;
    flex-shrink: 0;
}

.ph-body {
    padding: 16px 20px;
}

.ph-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.ph-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 24px 16px;
    color: #94a3b8;
    font-size: 0.85rem;
}

.ph-empty i {
    font-size: 1.5rem;
    margin-bottom: 8px;
    color: #cbd5e1;
}

.ph-load-more {
    padding-top: 12px;
    border-top: 1px solid #f1f5f9;
    margin-top: 8px;
}

.ph-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    width: 100%;
    padding: 8px 16px;
    border-radius: 10px;
    font-size: 0.8rem;
    font-weight: 600;
    border: none;
    cursor: pointer;
    transition: all 0.2s;
    color: #fff;
}

.ph-btn i {
    font-size: 0.7rem;
    color: #fff !important;
}

.ph-btn-more {
    background: #3b82f6;
}

.ph-btn-more:hover {
    background: #2563eb;
}

.ph-btn-less {
    background: #10b981;
}

.ph-btn-less:hover {
    background: #059669;
}
</style>
